import { map } from 'rxjs/operators/map';
import { TriggerSerializer } from '../../models';
import ajax from '../../utils/ajax';

class TriggerService {
  conductorUrl = process.env.REACT_APP_CONDUCTOR_ASSETS_URL || '';
  configurationPath = '/networkAsset/airfinder/trigger';
  configurationPathGroup = '/networkAsset/airfinder/triggers';

  /**
    Get Triggers by workflow id
    @param {String} siteId
    @param {String} workflowId
    @param {Object} store Redux store
    @returns {Observable} Observable that emits the normalized response
  */
  getByWorkflowId = (siteId, workflowId, store) => {
    return ajax(
      {
        url: `${this.conductorUrl}${
          this.configurationPathGroup
        }?workflowId=${workflowId}`,
        method: 'GET',
        responseType: 'json'
      },
      store
    ).pipe(map(data => data.response.map(TriggerSerializer.normalize)));
  };

  /**
    Create a Trigger
    @param {Object} trigger
    @param {Object} store Redux store
    @returns {Observable} Observable that emits the normalized response
  */
  create = (trigger, store) => {
    return ajax(
      {
        url: `${this.conductorUrl}${this.configurationPathGroup}`,
        body: TriggerSerializer.serialize(trigger),
        headers: { 'Content-Type': 'application/json' },
        method: 'POST',
        responseType: 'json'
      },
      store
    ).pipe(map(data => TriggerSerializer.normalize(data.response)));
  };

  /**
    Edit a Trigger
    @param {Object} trigger
    @param {Object} store Redux store
    @returns {Observable} Observable that emits the normalized response
  */
  edit = (trigger, store) => {
    return ajax(
      {
        url: `${this.conductorUrl}${this.configurationPath}/${trigger.id}`,
        body: TriggerSerializer.serialize(trigger),
        headers: { 'Content-Type': 'application/json' },
        method: 'PUT',
        responseType: 'json'
      },
      store
    ).pipe(map(data => TriggerSerializer.normalize(data.response)));
  };

  /**
    Delete a Trigger
    @param {Object} trigger
    @param {Object} store Redux store
    @returns {Observable} Observable that emits the response
  */
  delete = (trigger, store) => {
    return ajax(
      {
        url: `${this.conductorUrl}${this.configurationPath}/${trigger.id}`,
        body: '',
        headers: { 'Content-Type': 'application/json' },
        method: 'DELETE',
        responseType: 'json'
      },
      store
    );
  };
}

export default new TriggerService();



// WEBPACK FOOTER //
// ./src/services/trigger/index.js